import Backbone from 'backbone';
import $ from 'jquery';

import * as statusbar from 'components/StatusBar';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import FileState, {FileStateAttributes} from 'filestate/FileState';
import * as navigation from 'Navigation';
import {getStore} from 'redux-stores/Store';

import * as RequestDAO from '../RequestDAO';
import RequestDetailsTabState from './RequestDetailsTabState';
import RequestResponseTabState from './RequestResponseTabState';

class RequestToolbarState extends Backbone.Model {}

export default class RequestFileState extends FileState {
  static fileType: string;
  static openFile: (fileId: string) => JQueryPromise<unknown>;
  override defaults(): FileStateAttributes {
    return {
      ...super.defaults(),
      toolbar: new RequestToolbarState(),
      statusbar: new statusbar.SingleBufferStatusBarState(),
    };
  }

  override editURL(): string {
    return RequestDAO.requestEditorURL(this.id);
  }

  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  override initialize(...args: any): void {
    super.initialize(...args);

    const unsubscribe = getStore().subscribe(this.changeListener.bind(this));
    this.set({unsubscribe});

    const buffers = new navigation.BufferStates([
      new navigation.BufferState(),
      new navigation.BufferState({active: false}),
    ]);
    this.set({buffers});

    const buffer = buffers.at(0);
    buffer.tabs().add(new RequestDetailsTabState({requestId: this.id}));
    buffer.tabs().at(0).set({active: true});
    buffer.tabs().add(new RequestResponseTabState({requestId: this.id}));
  }

  override name(): string {
    return this.get('name') || 'Loading...';
  }

  override registerTitleAndURLSync(): void {
    this.on('change:name', () => {
      this.syncTitleAndURL();
    });
  }

  changeListener(): void {
    const {requestsById} = getStore().getState().models.requests.inputs;
    const request = requestsById[this.id];
    if (request) {
      this.set({name: request.name});
    }
  }

  cleanUp(): void {
    this.get('unsubscribe')();
  }
}

RequestFileState.fileType = ModelTypeConstants.REQUEST;

RequestFileState.openFile = (fileId: string) =>
  $.Deferred()
    .resolve(new RequestFileState({id: fileId}))
    .promise();
